import {configureStore} from "@reduxjs/toolkit" //组合子模块的方法
import fontSize from './modules/fontSize' //导入子模块
import user from './modules/user' //导入子模块


//配置
const store=configureStore({
    reducer:{
        fontSizeChange : fontSize,
        user : user,
    }
})

//导出
export default store
